import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFilterContext } from '../../context/FilterContext';
import FilterModal from '../FilterModal';
import styles from './MobileFilterButton.module.css';

const MobileFilterButton = ({ games }) => {
  const { hasActiveFilters } = useFilterContext();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  return (
    <>
      <button
        className={`${styles.filterButton} ${hasActiveFilters ? styles.active : ''}`}
        onClick={() => setIsFilterModalOpen(true)}
        aria-label="Filters"
      >
        <span className={styles.filterText}>Filters</span>
        {hasActiveFilters && <span className={styles.filterBadge}></span>}
      </button>

      <FilterModal
        games={games}
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
      />
    </>
  );
};

MobileFilterButton.propTypes = {
  games: PropTypes.array.isRequired
};

export default MobileFilterButton;
